import clsx from 'clsx';
import type { ClassValue } from 'clsx';

/**
 * Utility function to merge class names conditionally
 * Usage: cn('base-class', condition && 'conditional-class', { 'dynamic': isDynamic })
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
